export default __webpack_public_path__ + "media/zurb/img/ecommerce/jab_1-601ef1011f9bee7468539c5854e9aca1.png";